export const GOOGLE_API_KEY = 'AIzaSyB4Ns4sFYO1E_0yHwM1kvib8NG2-14zJ_E'
export const locationIcons = [
    '1.svg',
    '2.svg',
    '3.svg',
    '4.svg',
    '5.svg',
    '6.svg',
    '7.svg',
    '8.svg',
    '9.svg',
];
export const eventTypeSalon = [
    'wedding',
    'civil_wedding',
    'christening',
    'party',
    'conference',
    'festival_salon',
    'corporate',
]
export const eventTypeOrganizing = [
    'festival',
]
export const eventTypeCatering = [
    'corporate',
    'private_events',
    'playgrounds',
    'deliveries_to_individuals',
]
export const localeConfigurationObject = [
    {
        "name": "ro",
        "options": {
            "months": ["Ianuarie", "Februarie", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            "shortMonths": ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            "toolbar": {
                "exportToSVG": "Download SVG",
                "exportToPNG": "Download PNG",
                "menu": "Menu",
                "selection": "Selection",
                "selectionZoom": "Selection Zoom",
                "zoomIn": "Zoom In",
                "zoomOut": "Zoom Out",
                "pan": "Panning",
                "reset": "Reset Zoom"
            }
        }
    }
]

export const sectionsAccess = [
    'view_events',
    'payment_deadlines',
    'profitability',
    'events',
    'menus',
    'view_menus',
    'logistics',
    'logistics_checklist',
    'clients',
    'staff',
    'taxes',
    'event_sources',
    'event_tags',
    'event_sheet_templates',
    'feedback_forms',
    'costs',
    'offers',
    'invoices',
    'contracts',
    'export',
    //'stock',
    'import',
    'companies',
    'users',
    'notifications',
    'locations',
]
export const sectionsAccessEventPlanner = [
    'view_events',
    'payment_deadlines',
    'profitability',
    'events',
    'logistics',
    'logistics_checklist',
    'clients',
    'staff',
    'taxes',
    'event_sources',
    'event_tags',
    'event_sheet_templates',
    'feedback_forms',
    'costs',
    'offers',
    'invoices',
    'contracts',
    'export',
    'import',
    'companies',
    'users',
    'notifications',
    'event_types',
    'activities'
]
export const programCategories = [
    'before_event',
    'during_event',
    'after_event'
]

export const contractHeaderTemplate = `
<p style="margin-left: auto;" align="right">CONTRACT PRESTARI SERVICII NR. {contract_number}/{contract_date}<br>{company_name}<br>CIF: {fiscal_code}<br>Reg. Comerțului: {reg_com_number}<br>IBAN: {iban}<br>Adresa: {company_address}</p>
`
export const contractTemplates = {
    'contract': {
        'individual': {
            'template': `<div class="WordSection1"><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">CONTRACT</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Număr &icirc;nregistrare: {contract_number}</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: #081735; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&Icirc;ncheiat astăzi {contract_date}</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: #081735; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;"> </span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><strong><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">1. PĂRȚILE CONTRACTANTE </span></strong></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_name}, cu sediul &icirc;n {company_address}, &icirc;nregistrată la Oficiul Registrului Comerțului sub nr. {reg_com_number}, cod de identificare fiscală {fiscal_code} , cont IBAN {iban}, deschis la {bank} reprezentată de {legal_representative_name}&nbsp;&icirc;n calitate de {legal_representative_position}, numită &icirc;n continuare&nbsp;Prestator</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Și</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Dl./D-na <span style="background: white;">{client_name}</span>, domiciliate/a in <span style="background: white;">{client_address}, </span>denumit in continuare Beneficiar</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal; tab-stops: 45.8pt 91.6pt 137.4pt 183.2pt 229.0pt 274.8pt 320.6pt 366.4pt 412.2pt 458.0pt 503.8pt 549.6pt 595.4pt 641.2pt 687.0pt 732.8pt;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Locația:{location}</span></p><p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal; tab-stops: 45.8pt 91.6pt 137.4pt 183.2pt 229.0pt 274.8pt 320.6pt 366.4pt 412.2pt 458.0pt 503.8pt 549.6pt 595.4pt 641.2pt 687.0pt 732.8pt;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Data evenimentului:{event_date}</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Oră &icirc;ncepere: {time_start}</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Durata (ore):{duration}</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p></div><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB; mso-bidi-language: AR-SA;">&nbsp;</span></p><div class="WordSection2"><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_name}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{client_name}</span></span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_signature}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{client_signature}</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: right; line-height: normal; background: white;" align="right">&nbsp;</p></div><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB; mso-bidi-language: AR-SA;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal;"><span lang="RO" style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; margin-bottom: 0cm; line-height: normal; tab-stops: 45.8pt 91.6pt 137.4pt 183.2pt 229.0pt 274.8pt 320.6pt 366.4pt 412.2pt 458.0pt 503.8pt 549.6pt 595.4pt 641.2pt 687.0pt 732.8pt;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal;"><span lang="RO" style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal"><span lang="RO" style="font-family: 'Arial',sans-serif;">&nbsp;</span></p>`
        },
        'company': {
            'template': `<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">CONTRACT</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Număr &icirc;nregistrare: {contract_number}</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: #081735; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&Icirc;ncheiat astăzi {contract_date}</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: #081735; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;"> </span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><strong><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">1. PĂRȚILE CONTRACTANTE </span></strong></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_name}, cu sediul &icirc;n {company_address}, &icirc;nregistrată la Oficiul Registrului Comerțului sub nr. {reg_com_number}, cod de identificare fiscală {fiscal_code} , cont IBAN {iban}, deschis la {bank} reprezentată de {legal_representative_name}&nbsp;&icirc;n calitate de {legal_representative_position}, numită &icirc;n continuare&nbsp;Prestator</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Și</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{client_name} , cu sediul &icirc;n {client_address} , &icirc;nregistrată la Oficiul Registrului Comerțului sub nr. {client_reg_com_number} cod de identificare fiscală {client_fiscal_code} reprezentată de {client_legal_representative_name} &icirc;n calitate de {client_legal_representative_position} , numită &icirc;n continuare Beneficiar.</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;">&nbsp;</p><p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal; tab-stops: 45.8pt 91.6pt 137.4pt 183.2pt 229.0pt 274.8pt 320.6pt 366.4pt 412.2pt 458.0pt 503.8pt 549.6pt 595.4pt 641.2pt 687.0pt 732.8pt;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Locația:{location}</span></p><p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal; tab-stops: 45.8pt 91.6pt 137.4pt 183.2pt 229.0pt 274.8pt 320.6pt 366.4pt 412.2pt 458.0pt 503.8pt 549.6pt 595.4pt 641.2pt 687.0pt 732.8pt;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Data evenimentului:{event_date}</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Oră &icirc;ncepere: {time_start}</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Durata (ore):{duration}</span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB; mso-bidi-language: AR-SA;">&nbsp;</span></p><div class="WordSection2"><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_name}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{client_name}</span></span></p><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_signature}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {client_signature}</span></p></div><p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p><p class="MsoNormal"><span lang="RO" style="font-family: 'Arial',sans-serif;">&nbsp;</span></p>`
        }
    },
    'annex': {
        'individual': {
            'template': `
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal;" align="center">
<span lang="RO" style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-fareast-language: EN-GB;">ANEXA</span>
<span lang="RO" style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; mso-fareast-language: EN-GB;"><br><br>
.<span style="color: black;">Număr &icirc;nregistrare: {annex_number}</span><br><br><span style="color: #081735;">&nbsp;</span><span style="color: black;">&Icirc;ncheiat astăzi {annex_date}</span></span></p>
<ol>
<li class="MsoNormal" style="line-height: normal;"><strong><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">PĂRȚILE CONTRACTANTE&nbsp;</span></strong><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;"><br><br><span style="color: black;">{company_name}, cu sediul &icirc;n {company_address}, &icirc;nregistrată la Oficiul Registrului Comerțului sub nr. {reg_com_number}, cod de identificare fiscală {fiscal_code} , cont IBAN {iban}, deschis la {bank} reprezentată de {legal_representative_name}&nbsp;&icirc;n calitate de {legal_representative_position}, numită &icirc;n continuare&nbsp;Prestator</span><br><br><span style="color: black;">Și</span></span></li>
<li class="MsoNormal" style="line-height: normal;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;"><span style="color: black;">Dl./D-na&nbsp;<span style="background: white;">{client_name}</span>, domiciliate/a in <span style="background: white;">{client_address}, </span>denumit in continuare Beneficiar</span></span><br><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;"><br><br></span></li></ol>
<table style="border-collapse: collapse; width: 100%; height: 319.125px;" border="1"><colgroup><col style="width: 17.9176%;"><col style="width: 82.1882%;"></colgroup>
<tbody>
<tr style="height: 19.5938px;">
<td style="height: 19.5938px; text-align: center;">CAPITOL</td>
<td style="height: 19.5938px; text-align: center;">DESCRIERE</td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">DATĂ EVENIMENT</td>
<td style="height: 19.5938px;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{event_date}&nbsp;{time_start}, {duration}h</span></td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">NR PERS</td>
<td style="height: 19.5938px;">{guests_number}</td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">CHIRIE</td>
<td style="height: 19.5938px;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{location}</span></td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">SERVICII INCLUSE</td>
<td style="height: 19.5938px; text-align: left;">{services}</td>
</tr>
<tr style="height: 81.1875px; text-align: center;">
<td style="height: 81.1875px; text-align: center;">
<p>&nbsp;</p>
{title_food_menu}
<p>&nbsp;</p>
</td>
<td style="height: 81.1875px; text-align: left;">{food_menu}</td>
</tr>
<tr style="height: 81.1875px; text-align: center;">
<td style="height: 81.1875px; text-align: center;">
<p>&nbsp;</p>
{title_drink_menu}
<p>&nbsp;</p>
</td>
<td style="height: 81.1875px; text-align: left;">{drink_menu}</td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">BUGET</td>
<td style="height: 19.5938px; text-align: left;">{total}</td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">TERMENE DE PLATĂ</td>
<td style="height: 19.5938px; text-align: left;">{payment_deadlines}</td>
</tr>
</tbody>
</table>
<span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;"><span style="color: black;">Locația:{location}</span><br><br><span style="color: black;">Data evenimentului:{event_date}</span><br><br><span style="color: black;">Oră &icirc;ncepere: {time_start}</span><br><br><span style="color: black;">Durata (ore):{duration}</span><br><br>Meniu băuturi: {drink_menu}<br><br>Meniu m&acirc;ncare: {food_menu}<br><br>Meniuri staff: {staff_food_menu}<br><br>Meniu copii:{children_food_menu}<br><br>Meniuri speciale: {special_food_menus}<br><br>Număr invitați: {guests_number}<br><br></span>

<div class="WordSection2">
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_name}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{client_name}</span></span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_signature}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {client_signature}</span></p>
</div>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p>`
        },
        'company': {
            'template': `<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">ANEXA</span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Număr &icirc;nregistrare: {annex_number}</span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: #081735; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&Icirc;ncheiat astăzi {annex_date}</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: #081735; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;"> </span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; text-align: center; line-height: normal; background: white;" align="center"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><strong><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">1. PĂRȚILE CONTRACTANTE </span></strong></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_name}, cu sediul &icirc;n {company_address}, &icirc;nregistrată la Oficiul Registrului Comerțului sub nr. {reg_com_number}, cod de identificare fiscală {fiscal_code} , cont IBAN {iban}, deschis la {bank} reprezentată de {legal_representative_name}&nbsp;&icirc;n calitate de {legal_representative_position}, numită &icirc;n continuare&nbsp;Prestator</span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">Și</span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{client_name} , cu sediul &icirc;n {client_address} , &icirc;nregistrată la Oficiul Registrului Comerțului sub nr. {client_reg_com_number} cod de identificare fiscală {client_fiscal_code} reprezentată de {client_legal_representative_name} &icirc;n calitate de {client_legal_representative_position} , numită &icirc;n continuare Beneficiar.</span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p>
<table style="border-collapse: collapse; width: 100%; height: 319.125px;" border="1"><colgroup><col style="width: 17.9176%;"><col style="width: 82.1882%;"></colgroup>
<tbody>
<tr style="height: 19.5938px;">
<td style="height: 19.5938px; text-align: center;">CAPITOL</td>
<td style="height: 19.5938px; text-align: center;">DESCRIERE</td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">DATĂ EVENIMENT</td>
<td style="height: 19.5938px;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{event_date}&nbsp;{time_start}, {duration}h</span></td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">NR PERS</td>
<td style="height: 19.5938px;">{guests_number}</td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">CHIRIE</td>
<td style="height: 19.5938px;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{location}</span></td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">SERVICII INCLUSE</td>
<td style="height: 19.5938px; text-align: left;">{services}</td>
</tr>
<tr style="height: 81.1875px; text-align: center;">
<td style="height: 81.1875px; text-align: center;">
<p>&nbsp;</p>
{title_food_menu}
<p>&nbsp;</p>
</td>
<td style="height: 81.1875px; text-align: left;">{food_menu}</td>
</tr>
<tr style="height: 81.1875px; text-align: center;">
<td style="height: 81.1875px; text-align: center;">
<p>&nbsp;</p>
{title_drink_menu}
<p>&nbsp;</p>
</td>
<td style="height: 81.1875px; text-align: left;">{drink_menu}</td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">BUGET</td>
<td style="height: 19.5938px; text-align: left;">{total}</td>
</tr>
<tr style="height: 19.5938px; text-align: center;">
<td style="height: 19.5938px; text-align: center;">TERMENE DE PLATĂ</td>
<td style="height: 19.5938px; text-align: left;">{payment_deadlines}</td>
</tr>
</tbody>
</table>
<p class="MsoNormal" style="margin-bottom: 0cm; line-height: normal; tab-stops: 45.8pt 91.6pt 137.4pt 183.2pt 229.0pt 274.8pt 320.6pt 366.4pt 412.2pt 458.0pt 503.8pt 549.6pt 595.4pt 641.2pt 687.0pt 732.8pt;">&nbsp;</p>
<div class="WordSection2">
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_name}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; background: white; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{client_name}</span></span></p>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 10.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">{company_signature}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {client_signature}</span></p>
</div>
<p class="MsoNormal" style="mso-margin-top-alt: auto; mso-margin-bottom-alt: auto; line-height: normal; background: white;"><span style="font-size: 12.0pt; font-family: 'Arial',sans-serif; mso-fareast-font-family: 'Times New Roman'; color: black; mso-color-alt: windowtext; mso-ansi-language: EN-GB; mso-fareast-language: EN-GB;">&nbsp;</span></p>`
        }
    }
}
export const contractVariables = {
    'contract': [
        {
            'value': 'contract_number',
            'label': 'general.contract_number',
            'for_company': false
        },
        {
            'value': 'contract_date',
            'label': 'general.contract_date',
            'for_company': false
        },
        {
            'value': 'company_name',
            'label': 'settings.company.title',
            'for_company': false
        },
        {
            'value': 'company_address',
            'label': 'settings.company.address',
            'for_company': false
        },
        {
            'value': 'reg_com_number',
            'label': 'settings.company.reg_com_number',
            'for_company': false
        },
        {
            'value': 'fiscal_code',
            'label': 'settings.company.fiscal_code',
            'for_company': false
        },
        {
            'value': 'iban',
            'label': 'settings.company.bank_account',
            'for_company': false
        },
        {
            'value': 'bank',
            'label': 'settings.company.bank',
            'for_company': false
        },
        {
            'value': 'legal_representative_name',
            'label': 'settings.company.legal_representative_name',
            'for_company': false
        },
        {
            'value': 'legal_representative_position',
            'label': 'settings.company.legal_representative_function',
            'for_company': false
        },
        {
            'value': 'company_signature',
            'label': 'settings.company.signature',
            'for_company': false
        },
        {
            'value': 'client_name',
            'label': 'contracts.client.name',
            'for_company': false
        },
        {
            'value': 'client_address',
            'label': 'contracts.client.address',
            'for_company': false
        },
        {
            'value': 'client_email',
            'label': 'contracts.client.email',
            'for_company': false
        },
        {
            'value': 'client_phone',
            'label': 'contracts.client.phone',
            'for_company': false
        },
        {
            'value': 'client_iban',
            'label': 'contracts.client.bank_account',
            'for_company': false
        },
        {
            'value': 'client_bank',
            'label': 'contracts.client.bank',
            'for_company': false
        },
        {
            'value': 'client_reg_com_number',
            'label': 'contracts.client.reg_com_number',
            'for_company': true
        },
        {
            'value': 'client_fiscal_code',
            'label': 'contracts.client.fiscal_code',
            'for_company': true
        },
        {
            'value': 'client_legal_representative_name',
            'label': 'contracts.client.legal_representative_name',
            'for_company': true
        },
        {
            'value': 'client_legal_representative_position',
            'label': 'contracts.client.legal_representative_position',
            'for_company': true
        },
        {
            'value': 'client_signature',
            'label': 'contracts.client.signature',
            'for_company': false
        },
        {
            'value': 'location',
            'label': 'events.location',
            'for_company': false
        },
        {
            'value': 'event_date',
            'label': 'general.event_date',
            'for_company': false
        },
        {
            'value': 'time_start',
            'label': 'events.time_start',
            'for_company': false
        },
        {
            'value': 'duration',
            'label': 'events.duration',
            'for_company': false
        },
    ],
    'annex': [
        {
            'value': 'contract_number',
            'label': 'general.contract_number',
            'for_company': false
        },
        {
            'value': 'contract_date',
            'label': 'general.contract_date',
            'for_company': false
        },
        {
            'value': 'annex_number',
            'label': 'general.annex_number',
            'for_company': false
        },
        {
            'value': 'annex_date',
            'label': 'general.annex_date',
            'for_company': false
        },
        {
            'value': 'company_name',
            'label': 'settings.company.title',
            'for_company': false
        },
        {
            'value': 'company_address',
            'label': 'settings.company.address',
            'for_company': false
        },
        {
            'value': 'reg_com_number',
            'label': 'settings.company.reg_com_number',
            'for_company': false
        },
        {
            'value': 'fiscal_code',
            'label': 'settings.company.fiscal_code',
            'for_company': false
        },
        {
            'value': 'iban',
            'label': 'settings.company.bank_account',
            'for_company': false
        },
        {
            'value': 'bank',
            'label': 'settings.company.bank',
            'for_company': false
        },
        {
            'value': 'legal_representative_name',
            'label': 'settings.company.legal_representative_name',
            'for_company': false
        },
        {
            'value': 'legal_representative_position',
            'label': 'settings.company.legal_representative_function',
            'for_company': false
        },
        {
            'value': 'company_signature',
            'label': 'settings.company.signature',
            'for_company': false
        },
        {
            'value': 'client_name',
            'label': 'contracts.client.name',
            'for_company': false
        },
        {
            'value': 'client_address',
            'label': 'contracts.client.address',
            'for_company': false
        },
        {
            'value': 'client_email',
            'label': 'contracts.client.email',
            'for_company': false
        },
        {
            'value': 'client_phone',
            'label': 'contracts.client.phone',
            'for_company': false
        },
        {
            'value': 'client_iban',
            'label': 'contracts.client.bank_account',
            'for_company': false
        },
        {
            'value': 'client_bank',
            'label': 'contracts.client.bank',
            'for_company': false
        },
        {
            'value': 'client_reg_com_number',
            'label': 'contracts.client.reg_com_number',
            'for_company': true
        },
        {
            'value': 'client_fiscal_code',
            'label': 'contracts.client.fiscal_code',
            'for_company': true
        },
        {
            'value': 'client_legal_representative_name',
            'label': 'contracts.client.legal_representative_name',
            'for_company': true
        },
        {
            'value': 'client_legal_representative_position',
            'label': 'contracts.client.legal_representative_position',
            'for_company': true
        },
        {
            'value': 'client_signature',
            'label': 'contracts.client.signature',
            'for_company': false
        },
        {
            'value': 'location',
            'label': 'events.location',
            'for_company': false
        },
        {
            'value': 'event_date',
            'label': 'general.event_date',
            'for_company': false
        },
        {
            'value': 'time_start',
            'label': 'events.time_start',
            'for_company': false
        },
        {
            'value': 'duration',
            'label': 'events.duration',
            'for_company': false
        },
        {
            'value': 'drink_menu',
            'label': 'events.menu.drink_menu',
            'for_company': false
        },
        {
            'value': 'title_drink_menu',
            'label': 'events.menu.title_drink_menu',
            'for_company': false
        },
        {
            'value': 'food_menu',
            'label': 'events.menu.food_menu',
            'for_company': false
        },
        {
            'value': 'title_food_menu',
            'label': 'events.menu.title_food_menu',
            'for_company': false
        },
        {
            'value': 'staff_food_menu',
            'label': 'events.staff_menu',
            'for_company': false
        },
        {
            'value': 'children_food_menu',
            'label': 'events.children_menu',
            'for_company': false
        },
        {
            'value': 'special_food_menus',
            'label': 'events.special_menu',
            'for_company': false
        },
        {
            'value': 'guests_number',
            'label': 'general.number_of_guests',
            'for_company': false
        },
        {
            'value': 'services',
            'label': 'events.sheet.general.services',
            'for_company': false
        },
        {
            'value': 'staff',
            'label': 'events.menu.staff',
            'for_company': false
        },
        {
            'value': 'taxes',
            'label': 'general.taxes',
            'for_company': false
        },
        {
            'value': 'total',
            'label': 'events.sheet.general.total_value',
            'for_company': false
        },
        {
            'value': 'payment_deadlines',
            'label': 'events.menu.payment_deadlines',
            'for_company': false
        },
    ]
}
export const offerHeaderVariables = [
    {
        'value': 'company_name',
        'label': 'settings.company.title',
        'for_company': false
    },
    {
        'value': 'company_address',
        'label': 'settings.company.address',
        'for_company': false
    },
    {
        'value': 'reg_com_number',
        'label': 'settings.company.reg_com_number',
        'for_company': false
    },
    {
        'value': 'fiscal_code',
        'label': 'settings.company.fiscal_code',
        'for_company': false
    },
    {
        'value': 'iban',
        'label': 'settings.company.bank_account',
        'for_company': false
    }
]
export const contractHeaderVariables = {
    'contract': [
        {
            'value': 'contract_number',
            'label': 'general.contract_number',
            'for_company': false
        },
        {
            'value': 'contract_date',
            'label': 'general.contract_date',
            'for_company': false
        },
        {
            'value': 'company_name',
            'label': 'settings.company.title',
            'for_company': false
        },
        {
            'value': 'company_address',
            'label': 'settings.company.address',
            'for_company': false
        },
        {
            'value': 'reg_com_number',
            'label': 'settings.company.reg_com_number',
            'for_company': false
        },
        {
            'value': 'fiscal_code',
            'label': 'settings.company.fiscal_code',
            'for_company': false
        },
        {
            'value': 'iban',
            'label': 'settings.company.bank_account',
            'for_company': false
        }
    ],
    'annex': [
        {
            'value': 'annex_number',
            'label': 'general.annex_number',
            'for_company': false
        },
        {
            'value': 'annex_date',
            'label': 'general.annex_date',
            'for_company': false
        },
        {
            'value': 'company_name',
            'label': 'settings.company.title',
            'for_company': false
        },
        {
            'value': 'company_address',
            'label': 'settings.company.address',
            'for_company': false
        },
        {
            'value': 'reg_com_number',
            'label': 'settings.company.reg_com_number',
            'for_company': false
        },
        {
            'value': 'fiscal_code',
            'label': 'settings.company.fiscal_code',
            'for_company': false
        },
        {
            'value': 'iban',
            'label': 'settings.company.bank_account',
            'for_company': false
        },
    ]
}

const sheet1 = {
    'general': {
        'preparation_time_pick_up': {
            'type': 'time',
            'width': 'col-12',
            'class': '',
            'maxTime': true
        },
        'menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'drink_menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'food': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
        },
        'food_service': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_staff_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_staff': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_children_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_children': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },

        'add_taxes': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': 'taxes'
        },
    },
    'set_up': {
        'set_up_type': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.set_up.set_up_type.ballroom_cabaret',
                    'translate': true,
                    'value': 'ballroom_cabaret',
                },
                {
                    'label': 'events.set_up.set_up_type.theater',
                    'translate': true,
                    'value': 'theater',
                }
            ]
        },
        'number_tables': {
            'type': 'number',
            
            'width': 'col-6',
            'class': '',
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
        },
        'empty_number_tables': {
            'conditions': [
                {
                    'field': 'number_tables',
                    'condition': 'eq',
                    'value': 0
                },
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
            'type': 'null',
            
            'width': 'col-6',
            'class': ''
        },
        'tables_type': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'number_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            
            'width': 'col-6',
            'class': '',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'chairs': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'number_chairs': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_name': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_phone': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'chairs_provider_time': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cocktail_tereace_cocktail_number': {
            'type': 'number',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'cocktail_salon_cocktail_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'tablecloths': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
        },
        'tablecloths_provider_name': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': 'd-flex'
        },
        'tablecloths_provider_phone': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'tablecloths_provider_time': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'table_numbers': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
        },
        'table_numbers_provider_name': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'table_numbers_provider_phone': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'table_numbers_provider_time': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'table_arrangement': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                }
            ],
        },
        'table_arrangement_provider_name': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'table_arrangement_provider_phone': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'table_arrangement_provider_time': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'ballroom_cabaret',
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'candy_bar_tables': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'candy_bar_tables_number': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_name': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'candy_bar_provider_time': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cheese_bar_tables': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'cheese_bar_tables_number': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_name': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'cheese_bar_provider_time': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'gelato_bar_tables': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'gelato_bar_tables_number': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_name': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'gelato_bar_provider_time': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'lemonade_bar_tables': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'lemonade_bar_tables_number': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_name': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'lemonade_bar_provider_time': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'hall_plan': {
            'type': 'upload',
            'width': 'col-12',
            'class': '',
            'accept': '.doc,.docx,.pdf'
        },
        'add': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': {
                'candy_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'cheese_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'gelato_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'lemonade_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
            }
        },
        'textboxes': {
            'type': 'array_of_textboxes',
            'width': 'col-12',
            'class': '',
            'content': {
                'title': {
                    'type': 'text',
                    'width': 'col-12',
                    'class': '',
                },
            }
        }
    },
}
const sheet2 = {
    'general': {
        'preparation_time_pick_up': {
            'type': 'time',
            'width': 'col-12',
            'class': '',
            'maxTime': true
        },
        'menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'drink_menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'food': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
        },
        'food_service': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_staff_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_staff': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_children_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_children': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'cake': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'cake_provider_name': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': 'd-flex'
        },
        'cake_provider_phone': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'cake_provider_time': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'service_time_cake': {
            'type': 'time',
            'width': 'col-12',
            'class': '',
        },
        'add_taxes': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': 'taxes'
        },
    },
    'set_up': {
        'set_up_type': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.set_up.set_up_type.ballroom',
                    'translate': true,
                    'value': 'ballroom',
                },
                {
                    'label': 'events.set_up.set_up_type.club',
                    'translate': true,
                    'value': 'club',
                },
                {
                    'label': 'events.set_up.set_up_type.mixt',
                    'translate': true,
                    'value': 'mixt',
                }
            ]
        },
        'number_couches': {
            'conditions': [
                {
                    'condition': 'eq',
                    'field': 'set_up_type',
                    'value': 'club',
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'number_tables': {
            'type': 'number',
            
            'width': 'col-6',
            'class': '',
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
        'empty_number_tables': {
            'conditions': [
                {
                    'field': 'number_tables',
                    'condition': 'eq',
                    'value': 0
                },
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
            'type': 'null',
            
            'width': 'col-6',
            'class': ''
        },
        'tables_type': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'number_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            
            'width': 'col-6',
            'class': '',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'chairs': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
        'number_chairs': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_name': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_phone': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'chairs_provider_time': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cocktail_tereace_cocktail_number': {
            'type': 'number',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'cocktail_salon_cocktail_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'tablecloths': {
            'label': true,
            'type': 'tab-switch',
            
            'width': 'col-6',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
        'tablecloths_provider_name': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'd-flex'
        },
        'tablecloths_provider_phone': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'tablecloths_provider_time': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'tablecloths',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'table_numbers': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
        'table_numbers_provider_name': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'table_numbers_provider_phone': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'table_numbers_provider_time': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_numbers',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'table_arrangement': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                }
            ],
        },
        'table_arrangement_provider_name': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'table_arrangement_provider_phone': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'table_arrangement_provider_time': {
            'conditions': [
                {
                    'condition': 'or',
                    'field': 'set_up_type',
                    'value_1': 'ballroom',
                    'value_2': 'mixt'
                },
                {
                    'field': 'table_arrangement',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'candy_bar_tables': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'candy_bar_tables_number': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_name': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'candy_bar_provider_time': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cheese_bar_tables': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'cheese_bar_tables_number': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_name': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'cheese_bar_provider_time': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'gelato_bar_tables': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'gelato_bar_tables_number': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_name': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'gelato_bar_provider_time': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'lemonade_bar_tables': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'lemonade_bar_tables_number': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_name': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'lemonade_bar_provider_time': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'hall_plan': {
            'type': 'upload',
            'width': 'col-12',
            'class': '',
            'accept': '.doc,.docx,.pdf'
        },
        'add': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': {
                'candy_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'cheese_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'gelato_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'lemonade_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
            }
        },
        'textboxes': {
            'type': 'array_of_textboxes',
            'width': 'col-12',
            'class': '',
            'content': {
                'title': {
                    'type': 'text',
                    'width': 'col-12',
                    'class': '',
                },
            }
        }
    },

}
const sheet3 = {
    'general': {
        'preparation_time': {
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'parents_time': {
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'drink_menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'food': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
        },
        'food_service': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': ' bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_staff_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_staff': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_children_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_children': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'cake': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'cake_provider_name': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': 'd-flex'
        },
        'cake_provider_phone': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'cake_provider_time': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'service_time_cake': {
            'type': 'time',
            'width': 'col-12',
            'class': '',
        },
        'add_taxes': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': 'taxes'
        },
    },
    'set_up': {
        'number_guests_tables': {
            'type': 'number',
            
            'width': 'col-6',
            'class': ''
        },
        'empty_number_guests_tables': {
            'conditions': [
                {
                    'field': 'number_guests_tables',
                    'condition': 'eq',
                    'value': 0
                }
            ],
            'type': 'null',
            
            'width': 'col-6',
            'class': ''
        },
        'guests_tables_type': {
            'conditions': [
                {
                    'field': 'number_guests_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            
            'width': 'col-6',
            'class': '',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'chairs': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'number_chairs': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_name': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_phone': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'chairs_provider_time': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'number_staff_tables': {
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'empty_number_staff_tables': {
            'conditions': [
                {
                    'field': 'number_staff_tables',
                    'condition': 'eq',
                    'value': 0
                }
            ],
            'type': 'null',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'staff_tables_type': {
            'conditions': [
                {
                    'field': 'number_staff_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'presidium_number_of_peaple': {
            'conditions': [
                {
                    'field': 'presidium',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'presidium_type': {
            'conditions': [
                {
                    'field': 'presidium',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'candy_bar_tables': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'candy_bar_tables_number': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_name': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'candy_bar_provider_time': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cheese_bar_tables': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'cheese_bar_tables_number': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_name': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'cheese_bar_provider_time': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'gelato_bar_tables': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'gelato_bar_tables_number': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_name': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'gelato_bar_provider_time': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'lemonade_bar_tables': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'lemonade_bar_tables_number': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_name': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'lemonade_bar_provider_time': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cocktail_tereace_cocktail_number': {
            'conditions': [
                {
                    'field': 'tereace_cocktail_tables',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'cocktail_salon_cocktail_number': {
            'conditions': [
                {
                    'field': 'salon_cocktail_tables',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'another_services_info': {
            'conditions': [
                {
                    'field': 'another_services',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'hall_plan': {
            'type': 'upload',
            'width': 'col-12',
            'class': '',
            'accept': '.doc,.docx,.pdf'
        },
        'add': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': {
                'presidium': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'candy_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'cheese_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'gelato_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'lemonade_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'tereace_cocktail_tables': {
                    'type': 'checkbox',
                    
            'width': 'col-6',
            'class': '',
                },
                'salon_cocktail_tables': {
                    'type': 'checkbox',
                    
            'width': 'col-6',
            'class': '',
                },
                'another_services': {
                    'type': 'checkbox',
                    
            'width': 'col-6',
            'class': '',
                },
            }
        },
        'textboxes': {
            'type': 'array_of_textboxes',
            'width': 'col-12',
            'class': '',
            'content': {
                'title': {
                    'type': 'text',
                    'width': 'col-12',
                    'class': '',
                },
            }
        }
    },
}
const sheet4 = {
    'general': {
        'preparation_time': {
            'type': 'time',
            'width': 'col-12',
            'class': '',
            'maxTime': true
        },
        'parents_time': {
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'church_time': {
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'drink_menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'food': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
        },
        'food_service': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': ' bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_staff_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_staff': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_children_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_children': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'cake': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'cake_provider_name': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': 'd-flex'
        },
        'cake_provider_phone': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'cake_provider_time': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'service_time_cake': {
            'type': 'time',
            'width': 'col-12',
            'class': '',
        },
        'add_taxes': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': 'taxes'
        },
    },
    'set_up': {
        'number_guests_tables': {
            'type': 'number',
            
            'width': 'col-6',
            'class': ''
        },
        'empty_number_guests_tables': {
            'conditions': [
                {
                    'field': 'number_guests_tables',
                    'condition': 'eq',
                    'value': 0
                }
            ],
            'type': 'null',
            
            'width': 'col-6',
            'class': ''
        },
        'guests_tables_type': {
            'conditions': [
                {
                    'field': 'number_guests_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            
            'width': 'col-6',
            'class': '',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'chairs': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'number_chairs': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_name': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_phone': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'chairs_provider_time': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'number_staff_tables': {
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'empty_number_staff_tables': {
            'conditions': [
                {
                    'field': 'number_staff_tables',
                    'condition': 'eq',
                    'value': 0
                }
            ],
            'type': 'null',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'staff_tables_type': {
            'conditions': [
                {
                    'field': 'number_staff_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'presidium_number_of_peaple': {
            'conditions': [
                {
                    'field': 'presidium',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'presidium_type': {
            'conditions': [
                {
                    'field': 'presidium',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'candy_bar_tables': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'candy_bar_tables_number': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_name': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'candy_bar_provider_time': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cheese_bar_tables': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'cheese_bar_tables_number': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_name': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'cheese_bar_provider_time': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'gelato_bar_tables': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'gelato_bar_tables_number': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_name': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'gelato_bar_provider_time': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'lemonade_bar_tables': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'lemonade_bar_tables_number': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_name': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            
            'width': 'col-6',
            'class': ''
        },
        'lemonade_bar_provider_time': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cocktail_tereace_cocktail_number': {
            'conditions': [
                {
                    'field': 'tereace_cocktail_tables',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'cocktail_salon_cocktail_number': {
            'conditions': [
                {
                    'field': 'salon_cocktail_tables',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'another_services_info': {
            'conditions': [
                {
                    'field': 'another_services',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'hall_plan': {
            'type': 'upload',
            'width': 'col-12',
            'class': '',
            'accept': '.doc,.docx,.pdf'
        },
        'add': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': {
                'presidium': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'candy_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'cheese_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'gelato_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'lemonade_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'tereace_cocktail_tables': {
                    'type': 'checkbox',
                    
            'width': 'col-6',
            'class': '',
                },
                'salon_cocktail_tables': {
                    'type': 'checkbox',
                    
            'width': 'col-6',
            'class': '',
                },
                'another_services': {
                    'type': 'checkbox',
                    
            'width': 'col-6',
            'class': '',
                },
            }
        },
        'textboxes': {
            'type': 'array_of_textboxes',
            'width': 'col-12',
            'class': '',
            'content': {
                'title': {
                    'type': 'text',
                    'width': 'col-12',
                    'class': '',
                },
            }
        }
    },
}
const sheet5 = {
    'general': {
        'preparation_time': {
            'type': 'time',
            'width': 'col-12',
            'class': '',
            'maxTime': true
        },
        'grooms_time': {
            'type': 'time',
            
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'church_time': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'drink_menus_number': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'food': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
        },
        'food_service': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': ' bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_staff_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_staff': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-light',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_staff': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_staff',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_staff': {
            'type': 'time_menu',
            'class': 'bg-light',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_staff_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_staff',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'food_children_service': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                }
            ]
        },
        'food_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'swedish_buffet',
                'true': 'serving_at_the_table',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                }
            ],
        },
        'food_service_children': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'bg-dark',
            'values': {
                'false': 'all_at_the_same_time',
                'true': 'at_different_times',
            },
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                }
            ],
        },
        'service_time_all_children': {
            'type': 'time',
            'width': 'col-12',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'all_at_the_same_time'
                }
            ],
        },
        'service_time_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_service_children',
                    'condition': 'eq',
                    'value': 'at_different_times'
                }
            ],
        },
        'service_time_table_children': {
            'type': 'time_menu',
            'class': 'bg-dark',
            'conditions': [
                {
                    'field': 'food',
                    'condition': 'neq',
                    'value': 'swedish_buffet'
                },
                {
                    'field': 'food_children_service',
                    'condition': 'eq',
                    'value': false
                },
                {
                    'field': 'food_children',
                    'condition': 'eq',
                    'value': 'serving_at_the_table'
                }
            ],
        },
        'cake': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'cake_provider_name': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': 'd-flex'
        },
        'cake_provider_phone': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'cake_provider_time': {
            'conditions': [
                {
                    'field': 'cake',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'service_time_cake': {
            'type': 'time',
            'width': 'col-12',
            'class': '',
        },
        'add_taxes': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': 'taxes'
        },

    },
    'set_up': {
        'number_guests_tables': {
            'type': 'number',
            'width': 'col-6',
            'class': ''
        },
        'empty_number_guests_tables': {
            'conditions': [
                {
                    'field': 'number_guests_tables',
                    'condition': 'eq',
                    'value': 0
                }
            ],
            'type': 'null',
            'width': 'col-6',
            'class': ''
        },
        'guests_tables_type': {
            'conditions': [
                {
                    'field': 'number_guests_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            'width': 'col-6',
            'class': '',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'chairs': {
            'label': true,
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'number_chairs': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_name': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'chairs_provider_phone': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'chairs_provider_time': {
            'conditions': [
                {
                    'field': 'chairs',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'number_staff_tables': {
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'empty_number_staff_tables': {
            'conditions': [
                {
                    'field': 'number_staff_tables',
                    'condition': 'eq',
                    'value': 0
                }
            ],
            'type': 'null',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'staff_tables_type': {
            'conditions': [
                {
                    'field': 'number_staff_tables',
                    'condition': 'neq',
                    'value': 0
                }
            ],
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'presidium_number_of_peaple': {
            'conditions': [
                {
                    'field': 'presidium',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'number',
            'width': 'col-6',
            'class': 'border-grey-top'
        },
        'presidium_type': {
            'conditions': [
                {
                    'field': 'presidium',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'tab-switch',
            'width': 'col-6',
            'class': 'border-grey-top',
            'values': {
                'false': 'round',
                'true': 'rectangular',
            },
        },
        'candy_bar_tables': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'candy_bar_tables_number': {
            'conditions': [
                {
                    'field': 'candy_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_name': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'candy_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'candy_bar_provider_time': {
            'conditions': [
                {
                    'field': 'candy_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cheese_bar_tables': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'cheese_bar_tables_number': {
            'conditions': [
                {
                    'field': 'cheese_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_name': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'cheese_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'cheese_bar_provider_time': {
            'conditions': [
                {
                    'field': 'cheese_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'gelato_bar_tables': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'gelato_bar_tables_number': {
            'conditions': [
                {
                    'field': 'gelato_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_name': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'gelato_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'gelato_bar_provider_time': {
            'conditions': [
                {
                    'field': 'gelato_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'lemonade_bar_tables': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'label': true,
            'type': 'tab-switch',
            'width': 'col-12',
            'class': 'border-grey-top',
            'values': {
                'false': 'salon',
                'true': 'client',
            },
        },
        'lemonade_bar_tables_number': {
            'conditions': [
                {
                    'field': 'lemonade_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_name': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },
        'lemonade_bar_provider_phone': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'lemonade_bar_provider_time': {
            'conditions': [
                {
                    'field': 'lemonade_bar_tables',
                    'condition': 'eq',
                    'value': 'client'
                }
            ],
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'cocktail_tereace_cocktail_number': {
            'conditions': [
                {
                    'field': 'tereace_cocktail_tables',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'cocktail_salon_cocktail_number': {
            'conditions': [
                {
                    'field': 'salon_cocktail_tables',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'another_services_info': {
            'conditions': [
                {
                    'field': 'another_services',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'type': 'text',
            'width': 'col-12',
            'class': 'border-grey-top'
        },
        'hall_plan': {
            'type': 'upload',
            'width': 'col-12',
            'class': '',
            'accept': '.doc,.docx,.pdf'
        },
        'add': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': {
                'presidium': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'candy_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'cheese_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'gelato_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'lemonade_bar': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'tereace_cocktail_tables': {
                    'type': 'checkbox',
                    'width': 'col-6',
                    'class': '',
                },
                'salon_cocktail_tables': {
                    'type': 'checkbox',
                    'width': 'col-6',
                    'class': '',
                },
                'another_services': {
                    'type': 'checkbox',
                    'width': 'col-6',
                    'class': '',
                },
            }
        },
        'textboxes': {
            'type': 'array_of_textboxes',
            'width': 'col-12',
            'class': '',
            'content': {
                'title': {
                    'type': 'text',
                    'width': 'col-12',
                    'class': '',
                },
            }
        }
    },
}
const sheet6 = {
    'general': {
        'improvement': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true
        },
        'final_hour': {
            'type': 'time',
            'width': 'col-6',
            'class': ''
        },
        'moving': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'minTime': true
        },
        'number_of_participants': {
            'type': 'number',
            'width': 'col-12',
            'class': ''
        },
        'psi': {
            'type': 'input_with_options',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'options': [
                {
                    'label': 'events.sheet.general.psi.security',
                },
                {
                    'label': 'events.sheet.general.psi.first_aid',
                },
                {
                    'label': 'events.sheet.general.psi.firefighters',
                }
            ]
        },
        'timetable': {
            'type': 'upload',
            'width': 'col-12',
            'class': 'border-grey-top',
            'accept': '.pdf'
        },
        'day_laborer': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top',
        },
        'day_laborer_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'day_laborer',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'isu': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top',
        },
        'isu_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'isu',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'ucmr_ada': {
            'type': 'on-off',
            'width': 'col-12',
            'class': 'border-grey-top',
        },
        'ucmr_ada_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'ucmr_ada',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'other_details': {
            'type': 'text',
            'width': 'col-12',
            'class': 'border-grey-top'
        },

        'add_taxes': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'content': 'taxes'
        },
    },
    'bar': {
        'sale_bar': {
            'type': 'on-off',
            'width': 'col-12',
            'class': '',
        },
        'responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'managers': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'managers_fee': {
            'type': 'fee',
            'width': 'col-12',
            'class': '',
            'for': 'managers',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'bartender': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },

        'bartender_fee': {
            'type': 'fee',
            'width': 'col-12',
            'class': '',
            'for': 'bartender',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'help_bar': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'help_bar_fee': {
            'type': 'fee',
            'width': 'col-12',
            'class': '',
            'for': 'help_bar',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'sale_mode': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'label': 'sale_mode',
            'values': {
                'false': 'open_bar',
                'true': 'sale',
            },
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'sale': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'sale_mode',
                    'condition': 'eq',
                    'value': 'sale'
                }
            ],
        },
        'sale_provider': {
            'type': 'select_provider',
            'width': 'col-6',
            'class': '',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'sale_mode',
                    'condition': 'eq',
                    'value': 'sale'
                },
                {
                    'field': 'sale',
                    'condition': 'eq',
                    'value': 'provider'
                },

            ],
        },
        'sale_responsible': {
            'type': 'select_staff',
            'width': 'col-6',
            'class': '',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'sale_mode',
                    'condition': 'eq',
                    'value': 'sale'
                },
                {
                    'field': 'sale',
                    'condition': 'eq',
                    'value': 'provider'
                },

            ],
        },
        'supplies_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': 'border-grey-top',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'drinks': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.sheet.bar.drinks.location',
                    'translate': true,
                    'value': 'location',
                },
                {
                    'label': 'events.sheet.bar.drinks.salon',
                    'translate': true,
                    'value': 'salon',
                },
                {
                    'label': 'events.sheet.bar.drinks.provider',
                    'translate': true,
                    'value': 'provider',
                }
            ],
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'drinks_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'minTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },
        'drinks_return': {
            'type': 'on-off',
            'width': 'col-12',
            'class': '',
            'maxTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },
        'drinks_delivery_time': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'maxTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'neq',
                    'value': 'location'
                },
            ],
        },
        'drinks_return_time': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'minTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'salon'
                },
            ],
        },
        'drinks_return_time_2': {
            'type': 'time',
            'width': 'col-6',
            'class': '',
            'minTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
                {
                    'field': 'drinks_return',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'drinks_provider_name': {
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
                {
                    'field': 'drinks_return',
                    'condition': 'eq',
                    'value': true
                },
            ],
            'type': 'text',
            'width': 'col-6',
            'class': 'd-flex'
        },
        'drinks_provider_phone': {
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_drinks',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'drinks',
                    'condition': 'eq',
                    'value': 'provider'
                },
                {
                    'field': 'drinks_return',
                    'condition': 'eq',
                    'value': true
                },
            ],
            'type': 'text',
            'width': 'col-6',
            'class': ''
        },
        'glasses': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.sheet.bar.drinks.location',
                    'translate': true,
                    'value': 'location',
                },
                {
                    'label': 'events.sheet.bar.drinks.salon',
                    'translate': true,
                    'value': 'salon',
                },
                {
                    'label': 'events.sheet.bar.drinks.provider',
                    'translate': true,
                    'value': 'provider',
                }
            ],
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_glasses',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'glasses_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'minTime': true,
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_glasses',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'glasses',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },
        'glasses_type': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [{
                'label': 'events.sheet.bar.glasses.glass',
                'translate': true,
                'value': 'glass',
            }, {
                'label': 'events.sheet.bar.glasses.cartoon',
                'translate': true,
                'value': 'cartoon',
            }],
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_glasses',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'glasses',
                    'condition': 'neq',
                    'value': 'location'
                },
            ],
        },
        'protocol': {
            'type': 'text',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_protocol',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'other': {
            'type': 'text',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'configure_other',
                    'condition': 'eq',
                    'value': true
                },
            ],
        },
        'configure_supplies': {
            'type': 'button',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'sale_bar',
                    'condition': 'eq',
                    'value': true
                }
            ],
            'content': {
                'configure_drinks': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_menus_print': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_glasses': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_fruits': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_straws': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_napkins': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_bar_organizers': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_ice_buckets': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_soffits': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_garbage_bags': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_trash_cans': {
                    'type': 'checkbox',
                    'width': 'col-12',
                    'class': '',
                },
                'configure_ice': {
                    'type': 'checkbox',
                    'width': 'col-6',
                    'class': '',
                },
                'configure_protocol': {
                    'type': 'checkbox',
                    'width': 'col-6',
                    'class': '',
                },
                'configure_other': {
                    'type': 'checkbox',
                    'width': 'col-6',
                    'class': '',
                },
            }
        },

    },
    'set_up': {
        'truss': {
            'type': 'select_from_list',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.sheet.bar.drinks.location',
                    'translate': true,
                    'value': 'location',
                },
                {
                    'label': 'events.sheet.bar.drinks.salon',
                    'translate': true,
                    'value': 'salon',
                },
                {
                    'label': 'events.sheet.bar.drinks.provider',
                    'translate': true,
                    'value': 'provider',
                }
            ],
        },
        'truss_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
        },
        'truss_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'isMulti': true,
            'conditions': [
                {
                    'field': 'truss',
                    'condition': 'eq',
                    'value': 'provider'
                },
            ],
        },

        'backstage_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': 'border-grey-top',
            'isMulti': true
        },
        'backstage_details': {
            'type': 'text',
            'width': 'col-12',
            'class': '',
        },
        'btl_logistics': {
            'type': 'select_staff',
            'width': 'col-6',
            'class': 'border-grey-top',
        },
        'btl_logistics_fee': {
            'type': 'fee',
            'width': 'col-6',
            'class': 'border-grey-top',
            'for': 'btl_logistics',
        },
        'products': {
            'type': 'product_btl',
            'width': 'col-12',
            'class': '',
            'options': [
                {
                    'label': 'events.sheet.bar.drinks.location',
                    'translate': true,
                    'value': 'location',
                },
                {
                    'label': 'events.sheet.bar.drinks.salon',
                    'translate': true,
                    'value': 'salon',
                },
                {
                    'label': 'events.sheet.bar.drinks.provider',
                    'translate': true,
                    'value': 'provider',
                }
            ],
        },
        'textboxes': {
            'type': 'array_of_textboxes',
            'width': 'col-12',
            'class': '',
            'content': {
                'title': {
                    'type': 'text',
                    'width': 'col-12',
                    'class': '',
                },
            }
        }
    },
    'access': {
        'tichets': {
            'type': 'on-off',
            'width': 'col-12',
            'class': ''
        },
        'tichets_from': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'tichets',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'tichets_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'tichets',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'tichets_from',
                    'condition': 'eq',
                    'value': 'provider'
                }
            ],
        },
        'tichets_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'tichets',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'tichets_from',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
        },
        'bracelets': {
            'type': 'on-off',
            'width': 'col-12',
            'class': ''
        },
        'bracelets_from': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'bracelets',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'bracelets_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'bracelets',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'bracelets_from',
                    'condition': 'eq',
                    'value': 'provider'
                }
            ],
        },
        'bracelets_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'bracelets',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'bracelets_from',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
        },
        'guestlist': {
            'type': 'on-off',
            'width': 'col-12',
            'class': ''
        },
        'guestlist_from': {
            'type': 'tab-switch',
            'width': 'col-12',
            'class': '',
            'values': {
                'false': 'salon',
                'true': 'provider',
            },
            'conditions': [
                {
                    'field': 'guestlist',
                    'condition': 'eq',
                    'value': true
                }
            ],
        },
        'guestlist_provider': {
            'type': 'select_provider',
            'width': 'col-12',
            'class': '',

            'conditions': [
                {
                    'field': 'guestlist',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'guestlist_from',
                    'condition': 'eq',
                    'value': 'provider'
                }
            ],
        },
        'guestlist_responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
            'conditions': [
                {
                    'field': 'guestlist',
                    'condition': 'eq',
                    'value': true
                },
                {
                    'field': 'guestlist_from',
                    'condition': 'eq',
                    'value': 'salon'
                }
            ],
        },
        'other': {
            'type': 'text',
            'width': 'col-12',
            'class': ''
        },

    },
    'activations': {
        'responsible': {
            'type': 'select_staff',
            'width': 'col-12',
            'class': '',
        },
        'activations_list': {
            'type': 'select_activation',
            'width': 'col-12',
            'class': 'border-grey-top ',
        },


    },
}
export const eventSheet = {
    'wedding': sheet5,
    'christening': sheet4,
    'civil_wedding': sheet3,
    'party': sheet2,
    'conference': sheet1,
    'festival_salon': sheet1,
    'festival': sheet6,
    'private_events': sheet2,
    'corporate': sheet1,
    'playgrounds': sheet1,
    'deliveries_to_individuals': sheet1,
}

export const requiredFields = {
    'wedding': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
    'christening': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
    'civil_wedding': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
    'party': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
    'conference': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
    'festival_salon': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
    'festival': {
        general: []
    },
    'private_events': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
    'corporate': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
    'playgrounds': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
    'deliveries_to_individuals': {
        general: [
            'menus_number',
            'drink_menus_number'
        ]
    },
}

export const offerTemplate = `<div class="WordSection1">
<div dir="ltr" align="left">
<table class="table-info" style="width: 100%; height: 100px; border-collapse: collapse; border-width: 0px; background-color: rgb(108, 93, 211);" border="0"><colgroup><col style="width: 23.7171%;" width="171"><col style="width: 76.1442%;" width="549"></colgroup>
<tbody style="background-color: rgb(108, 93, 211);">
<tr style="background-color: rgb(108, 93, 211);" height="20">
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">Client</span></strong></p>
</td>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">{client_name}</span></strong></p>
</td>
</tr>
<tr>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">Dată montaj</span></strong></p>
</td>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">{installation_date}</span></strong></p>
</td>
</tr>
<tr>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">Dată eveniment</span></strong></p>
</td>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">{date}</span></strong></p>
</td>
</tr>
<tr>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">Locație</span></strong></p>
</td>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">{location}</span></strong></p>
</td>
</tr>
<tr>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">Responsabil</span></strong></p>
</td>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">{user}</span></strong></p>
</td>
</tr>
<tr >
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">Valabil p&acirc;nă la</span></strong></p>
</td>
<td style="padding: 2px; border-width: 0px;background-color: rgb(108, 93, 211)" height="20">
<p dir="ltr"><strong><span style="color: rgb(255, 255, 255);">{validity}</span></strong></p>
</td>
</tr>
</tbody>
</table>
</div>
<div dir="ltr" align="left" style="margin-top: 40px">
{table}
</div>
</div>`
export const offerVariables = [
    {
        'value': 'client_name',
        'label': 'offers.client_name'
    },
    {
        'value': 'installation_date',
        'label': 'offers.installation_date'
    },
    {
        'value': 'date',
        'label': 'offers.templates.date'
    },
    {
        'value': 'location',
        'label': 'offers.location'
    },
    {
        'value': 'user',
        'label': 'offers.user'
    },
    {
        'value': 'validity',
        'label': 'offers.validity'
    },
    {
        'value': 'table',
        'label': 'offers.table'
    },
]
export const offerHeaderTemplate = `
<table style="border-collapse: collapse; width: 100%;" border="1"><colgroup><col style="width: 15.8776%;"><col style="width: 84.1224%;"></colgroup>
<tbody>
<tr>
<td><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALkAAACUCAYAAADPn4i0AAAABHNCSVQICAgIfAhkiAAAABl0RVh0U29mdHdhcmUAZ25vbWUtc2NyZWVuc2hvdO8Dvz4AAAArdEVYdENyZWF0aW9uIFRpbWUASm8gMDEgZmViIDIwMjQgMTk6MTg6MTUgKzAyMDBHr1AkAAASX0lEQVR4nO2db2wUZ37HvzShwFg1hrEf0uLFgchrzE6OS9zGgITLDn1zCF7kwnn9IpEiRSr9E/ekJFL7xiEXSynXNqjt0rSofUHaSN0l1RGJ5KoKtIugwjhV2iM3G4c/OmNY4PSYRcbIC0mUbF/Ys+w8M7M7MzuzszP7fCTL2tmdZ772fuc3v3n+/GZZqVQqgcMJMb/htwAOx2u4yTmhh5ucE3q4yTmhh5ucE3q4yTmhh5ucE3q4yTmhh5ucE3q4yTmhh5ucE3oe91uAE5LJJDKZjN8yOBaRJAmjo6MghPhy/MBFckVRuMEDhqIoSKfTvh0/kCbnBA8/v7fAmZzDsUsgc/JKEokERkZG/JbBYaCU4sCBA37LAMAjOacF4CbnhB5uck7o4SbnhB5uck7oCXzvSqOhlGp+A4sjepzmhZvcApRSZDIZ5HI500ENQgji8ThkWfZt+JpjDDd5DVKplKUhaUop0uk0stks4vE477tvInhObgKlFGNjY7bnXKhmP3DggCal4fgHN7kBqsFNUxNBABEESKLouA1O4+DpigHJZNIwCieiUUidos7ctFiEUiggffkKaLH4aDulSCaTGB8f53m6j/BIzpBMJnXRlwgCju6WMdIXNYzeRBAgRyIY374NiWhU854a0Tn+wU1egdqLUokkiji6WwYRhJr7E0HASF/U0Oh8Drx/cJNXYHSTOfr9rbbbkSPduojv56KBVoebvAI22o7v2G4pgrMQQdCdHJRSfhPqE/zGcwmjdKJa70kt1N4XpVAob1MUxfLo6HfffYdjx45hYmICd+7cQSwWc6zFTXK5HFauXIlnnnkGIyMj2LBhg9+SasJNboIcidTdRowx+ezsrOV93333XZw/f778OpfL1a3HLR4+fIiJiQlMTEzgww8/xOOPN7eNeLqyhBcmkjqZrkYbg0NBSW2mp6f9llATbnITulatqruNyj5zu7zyyit1H99rnn/+efT29votoybNfZ1pIF1dXZrXuYo0wy3sDAgNDQ3h6aefxu3bt13X4QaCIODJJ5/0W4YluMmXYA1IHzyou81c4W5d+69ZswZr1qypW0erw9OVJdhej3pSDRWFuRo0Sw9Jq8FNvgQhRGf05C8uOm4vdemy7kThiyv8gZu8gng8rnmduXEDmRs3bLdDi0WkL1/WbOOLKfyDm7wCSZJ0RkxfvqJLO6pBi0XDK0AikahbH8cZ/MazAkIIEokEkslkeZtq2nh3N0b6olX2XkxR2AgOLBrcSRQ/ceIEJicnsW7dOtv7esnVq1cxMDCAF154AatXr/ZbTk24yRlkWS6v7lFR049sPg9JFBET1y4unFi1CkqhAFp8gGw+b3izKkmSo6Vw7733Hk6dOgUAuHTpkvM/yCNu3boFRVFw+PBhv6XUhJvcANWU7MxBWiwiUyxaztMlScL4+Ljt45dKJZw7d872fo1menoaX3zxBbZs2eK3lKrwnNyEkZGRuvLoRCLhyOAAsGzZMrz00kuOj90odu/e3fQGB3gkr8rIyAhkWUYmk7E8H9ytpyrs2bMHmzdvxs2bN+tqxyva2trw7LPP+i3DEtzkNSCElM2uKApyuRwopZrJVoQQxGIx18tQbNq0CZs2bXK1zVaEm9wihBDIsgxZlv2WwrEJz8k5oYebnBN6eLpigKIooJTWlZqkUinkcjlPcnWOPbjJK2DrHlJKHRm0snKWoiiO6yOeOXMG169ft318lq+//hqyLLfsTSw3OR4VAGKXp6mGt2NORVF0S9ecFAN9//338dFHH1k+bi0++eQTvPPOO+jv73etzaDQ8jl5KpWqWpwzm81aXm9Zq1qWavZUKlW1nW+//RYnT560dEw7nD592vU2g0BLm9xK1Vq1nqEVjD63SuzSbatV9faxxx7D8PCwpWPaYe/eva63GQRaNl0xqzgr9sXQvX0IF4/9Y3mbavTR0VHT9lKplK69rS//McS+GG6cP4MrJ/9D854a9c2KgQ4PD+Opp55CPp+3+ZcZs3379padz96SJjczeO++/Yju+xEAoHB5CvnzZ8rvZTIZxONxw9U9Rs+OF/ti6N6xCwAQ3fcjRHbswsTf/AQPCo9qr9Qy+sDAAAYGBhz8hZxKWi5dMTL4KrEL214/WDY4AET37delGmYlnVmDL7b3pm7b9jcOonfffs12XvXWe1rK5EY9H6vELsh/eQRi3xbd9u1vHNRsY+eZA8YnzdaX/8Tw+KvELkR27ILYp13QbCfv59inZUxuFjHNDAksmpKNvJlMptw7YnTS9O7brzth2DbVXJ1tNyhVsxxRKvl26JYxuVGk3Pb6waqGBGAYebPZLDKZjO6kEftimpTHDNXoRulQaPnqG5Qmfrn48+U14Lb7xZvMaAmTG0XcxWhae8K/ashKzNKL3r37dduqtWuUDoW6WP/Drxd/bhdQ+vIaStnPtKafu+/JYVvC5EY3hmrPhxWMjM5i9aRh22WvEi1XrL/S9P+nXwTuBi1hcjaKR/dZj7gq3Tt2mZ4Yld2FdjG6SoQ6N/eB0JucTSvsRvFKjLoVjboL7WCkp+WiuceE3uRuRHEVozy6Wu+MVVhN6lRfjjuEfsSTNQubA9tF7VcvXMpB7IsZzk1x0uYqsUs3Gtqqw/BuE+pIbtRT4ZYpu3fscqUtFaFTa2iel7tHqE3OPiLFaS7eCNZGtfO8m+kZQUEn1CbXpSrR5l0wEGFOQJ6Tu0eoc3LWKIXLUyhcnvJJjT24yd0j1CZnqZw6GwT4zac7hDpd4QbhACE3OfvkiCDBn0zhHqFOV2RZhiRJgeuOM3riBcc5oTY58KiGIad1CXW6wuEA3OScFoCbnBN6uMk5oYebnBN6At+7kk6n+SIDTlV4JOeEnsCZnA+SBBNpfY9vxw6cydWHU3GzBwepuwfDgzt9O/6yUsnH0kYcDaXsZ35L8J1lcfcLnAYukocVr2qOcLjJm4O5+55Vj+JwkzcFpenbfksINdzkfuNhDUDOItzkPlP6deOqu7Yq3OR+wqN4Qwi1yZt9xTsbxen8nE9KnBEUvYGfu1JJJpMBpRS5XE6z5I0QAkmSEIvFmmdp2e0C0v/1CQAgd3MGSn6m/BZp74C0vgdbujdAWt8D0t7hl0oN6cmzAKrrlfu3+iXPlFAMBqlF8a2s5SSEOHoEuJtQSpH86V9D+dXVmp8l7R2I938PicGhBigzhs7P4cjpkxpjm0HaOzA8uNOx2b0YDAq8yTOZjKPHkMiyjEQi0fConkqlHM2alPu3YnhwZ8OjenrybDmC2yExOOToxOQmZ6hlcCIKoIWi+fuE4OjRo15IM6Ruve0d+KeXX/VCmiG1DF5Lr9Tdg7d/+JKtY3ph8sDm5GbP7ZF6OzG8px+x3s5Hny0UkZ2cwfGff6lrI5VKNSR1MdMb39aD+OAGa3rn55CePNuQ1EXJzxgafHjPZki9XZb0KvkZZKYu+p6nP/bWW2+95asChxw6dEjXe/L2j3dieE8/iChotrcJyyH1diE+2IM2YTlyV+6U35udncXGjRs9T1tYvUQU8Od/uA17409V1fs/v7yNhQffPNJ7/x6e7Fznedpy5PRJ0Pl7Or3xbT229F67Q/HcpijaVqy0dNxlG3/HnT+ggkB2IRo98/LtH+/URBcjiCggPqj9khrxoFgjva++OGBJ70/+bKdW7/wcjn9qP0e2Q2bqou4msx69R06f9ESnVQJpcrZ2t9TbWfMLUFG/iEbC6o1v67Gl99UXtXlqZYT1gi/y1zWvh/dstqV3+AfaEtle661FIE3ORsU/fdHezQoRBUiVOaXHT1xj2x7+wWZb+8d6O7V65+csdec5RbmpbTs+aG9VT3zbBl0093PgKJAmZ3NxNke0whYmMnlpcjf06tq8751pWEM60UvWavfxM5oHzuSsGZ0ahqxt07yenZ01+WR9sHoli5d9FvaknPXINOwVwi29uZveXXlqETiTu9ULkrt6R/O6q8u9h1xVwuqld837lasxe/eB5nVX+2rHmqpBmHabXa8VAmlySZLKr2mhqOkSrKddLzDSW20AxYzcFe2VxqvV72zXpBOtQOP0WiFwJgf0hsxOXjf5pDG0UET2AnNZrjCi12Qn7V26jU4ML/vJpW6tIbMX7P1/c1fuNFRvLQJp8lhM+8DZ3JVZW9H8Hz7Qr4r3cjCI1Xtm8rqtCMnqZU3oNjEm6h7/zylbeo//XPvwMb9HPANpcna6LC0UceSDzyx9EUc++F8ozAkxPj7uusZKZFkG6dQOgx/8+3OO9Q4/5+2wfrz/e5rX9erdxbTXaAI5rN/W1obBwUF8/PHH5W0LD74pDylLvfqbSFoo4q/++QI+/Vy7aFiSJM/nrrS1tWHj6k5kL5yvW6/cvxV7n3nOW70rVqKrfTU+/dWjMhlW9L7x04zuipoYHIK8xXok92JYP9CzEM2mrRJRAFkroEtc7CZk8+9KTpw44Zk+DbcLSL3/r4aTnir1zhYWdJGw/LkGz0I8cuokMlMX9To81MtnITKozwJijV6+UauSpxNCMDo66qm+SkoPvyqnAazRLelt78Crf7DPU40sw4M70dW+OjB6zQh0JFdRFAXJZNLymk5ZlhtqcAAoTd8Cri2mHpmpizg+ec7yULfTBQhuYXfhRD16+aKJKlBKkclkdOs7VQghIIQgkUg0tLtQpfTltcXV+UvQ+Tlkpz7XrZdUIe0dIO2rMfzckOe9KVZolF5ucotQSss/7GCMX7Amr2RxAtM90PtzIL/V0RSmroaXernJA0w1k3Mewava2qSp6q6s+M2aHwlKHRPA/+mzdgh074qKmo8DQDabNTS3mpOrtVf8TGHU/HZ2/h6UmzP6qa1LQ+CkfTVi63sQW9/jawpTmY/T+XtNr5cl0OmKoihIp9OO5oI3uv5KafoWlP++gOOfnnW04MGP+ivpybPITn3uKGI71ctz8iXsFBOqRSPMrigKkn/7d6AFF2ZLNsDsSn5maSFz/emIXb3c5ACSyWQ5NakGESqWXxVrz7kghGB8fNz1iVqe6W3vwNs/fNHV2X22KmV5pLelTV4rehNBQLy7G1KnCEkU9fsXi1AKBeQKd5G5ccO4DRejekP0uhjV6fwc3vzZB6bRWxJFxETRc70ta3JKKQ4cOGD4XiIahRzp1kSWmu0Vi8jcyCObzxtGoUQiUZfRFUXB2NhY4/TWOSKq5Gfw5s/+rSn0emHypp+FSCnF2NgYFhYWNNuJIOAvfu93IUciaFu+3FabbcuXQ+oUMfjEOrQtX45cQdt/rZaQcNIDQynFa6+9ptvuqd6l9ZNOejTo/Bxe//d/MdR7eGgnBn/7Cdf1zt6/B2HFCmzsekK3rxezEJve5IcOHcL09LRmmySKOPz7Q7aiixHqlyFHuvExc4zZ2VksLCzYNrpRZS85EsH4ju2u6QVgaBy7lbXo/Bz+6NgR3XZVr11zW9W78NVDXLtDDfW2XAUto5xW/QLchAgCju6WNdsopaZ97maMjY0Z6h39vrsrY0b6onq9DipVGX0+EY16opdts5GVtZrW5Iqi6HolJFF0/QtQMTO61TLLiqLoy094rJc92en8HI6csmYcJa+faJWIRjHSF3VNYyVGJ7sdvfXQtCZnzWX0pboNEQQkotov2aiOoRGsXkkUPdcriaJOr2IyS5CFjaKSKHpmcBU5EnGstx6a0uRGxvIqIrKM9EV1XWS1ormR3oTHhlGRI90avVYKgmamLuq6Chv1/zXSe2bqc0+P2ZQm1xX0FI37Zr2CNWitWonZbFbzWo5EGqaXCIJeb43qWqyp5Eik7ptiqxBBQDzSrdnG1l50m6Y0OZuLNyoqqrAnVS2T66J4tNczbUbo9M7PGa7NVN/T5+L+6/UyZWk6kxsNgTcyiquw0YaN1iqs3kZGxUpizP/ILAXI+hjFVYgg6PR6WXO96UzOpipyJOKLDqsnFqs3Jq71Qk5NZOakNEtZ2EKhfulV+89VvKx62/TzyWmxiOQvjC+9DdWxlLKwg0NsqpIr3EWucLeR0gxRFzWwgy1s/uuXXna438sFGE1nctY0SqEAFIKzbMxscpIf0Pl7+gKejJmaSa+Sn8HTaIHlb03xtGQTjEY/m2qJXQ2afbkaWzbaLZrO5PF43G8JhhBCysWMKkkkEj6oqQ1p16+iJ+0dvhffNEPq9u7x6k051dbrZ/jYpVZZC6d6S9d/DRQf1iPNkFplIuj8nOd903aQ1j8yeMvOJ+dw6qHp0hUOx224yTmhh5ucE3q4yTmhh5ucE3q4yTmhh5ucE3q4yTmh5/8BULPoZnqdWycAAAAASUVORK5CYII=" width="69" height="55"></td>
<td style="text-align: right;">
<div>{company_name}</div>
<div>CIF: {fiscal_code}</div>
<div>Reg. Comerțului: {reg_com_number}
<div>IBAN: {iban}</div>
<div>Adresa: {company_address}</div>
</div>
</td>
</tr>
</tbody>
</table>`